import store from '../store';
import { DASHBOARD_TYPES } from '../common/constants';

export function dashboardGuard(to, from, next) {
  if ([DASHBOARD_TYPES.ORGANIZATION, DASHBOARD_TYPES.SCHOOL].includes(store.getters['auth/getLoggedInUserDashboard'])) {
    next();
  } else next({ name: 'student-home' });
}
